import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from './api';

// Créer une nouvelle Commande
export const useCreateCommande = () => {
  const queryClient = useQueryClient();
  const authUser = localStorage.getItem('authUser');
  return useMutation({
    mutationFn: (data) =>
      api.post('/commandes/createCommande', data, {
        headers: {
          Authorization: `Bearer ${authUser?.token}`,
        },
      }),
    onSuccess: () => queryClient.invalidateQueries(['commandes']),
  });
};

// Mettre à jour une Commande
export const useUpdateCommande = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ commandeId, data }) =>
      api.put(`/commandes/updateCommande/${commandeId}`, data),
    onSuccess: () => queryClient.invalidateQueries(['commandes']),
  });
};
// Lire toutes les commandes
export const useAllCommandes = () =>
  useQuery({
    queryKey: ['commandes'],
    queryFn: () =>
      api.get('/commandes/getAllCommandes').then((res) => res.data),
  });

export const usePagignationCommandes = (
  page = 1,
  limit = 30,
  search = '',
  boutique = null,
  statut = null,
  today = null
) =>
  useQuery({
    /**
     * AJOUT (cache pro):
     * Avant: queryKey = ['commandes', page, limit] => collision/cache incohérent
     * quand on change search/boutique/statut/today.
     *
     * Maintenant: on inclut les filtres pour un cache correct par combinaison.
     * NB: on ne change pas le nom du hook ni l'URL API.
     */
    queryKey: ['commandes', page, limit, search, boutique, statut, today], //  clé dépendante
    queryFn: () =>
      api
        .get('/commandes/getPagignationCommandes', {
          /**
           * AJOUT:
           * On passe les filtres au backend pour filtrer AVANT pagination.
           */
          params: {
            page,
            limit,
            search: search || undefined,
            boutique: boutique ?? undefined,
            statut: statut || undefined,
            today: today ? '1' : undefined,
          },
        })
        .then((res) => res.data),
    keepPreviousData: true, //  pagination fluide
    staleTime: 1000 * 30,
  });

// Produits les plus vendu
export const useGetTopProduitCommande = () =>
  useQuery({
    /**
     * AJOUT (cache pro):
     * Avant: queryKey = ['commandes'] => collision avec d'autres requêtes "commandes"
     * (liste, pagination, etc.) et rafraîchissements inutiles.
     *
     * Maintenant: clé dédiée, donc cache stable et indépendant.
     * NB: on ne change pas le nom du hook ni l'URL API.
     */
    queryKey: ['commandes', 'top-produits'],
    queryFn: () => api.get('/commandes/getTopProduits').then((res) => res.data),
    staleTime: 1000 * 60 * 5, // 5 minutes (les tops ne changent pas à chaque seconde)
  });

// Obtenir une Commande
export const useOneCommande = (id) =>
  useQuery({
    queryKey: ['commandes', id],
    queryFn: () =>
      api.get(`/commandes/getOneCommande/${id}`).then((res) => res.data),
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 1, //chaque 1 minutes rafraichir les données
  });

// Ajouter une COMMANDE et Decrementer la quantité au Stock de PRODUIT
// export const useDecrementMultipleStocks = () => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: (items) =>
//       api.post('/commandes/decrementMultipleStocks', { items }),
//     onSuccess: () => queryClient.invalidateQueries(['commandes']),
//   });
// };

// Supprimer une Commande
export const useDeleteCommande = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ commandeId, items }) =>
      api.post(`/commandes/deleteCommande/${commandeId}`, {
        items,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(['commandes']);
      queryClient.invalidateQueries(['commandes']); // si tu veux la liste à jour
    },
  });
};
